import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';
import { GitBranch } from 'lucide-react';

function ConditionNodeComponent({ data, selected }) {
  const conditionField = data.condition_field || 'order.total';
  const conditionOperator = data.condition_operator || '>';
  const conditionValue = data.condition_value || '0';
  
  const formatCondition = () => {
    const fieldLabels = {
      'order.total': 'Order Total',
      'order.items_count': 'Items Count',
      'customer.orders_count': 'Customer Orders',
      'customer.total_spent': 'Total Spent',
      'checkout.total_price': 'Cart Value',
    };
    const operatorLabels = {
      '>': '>',
      '<': '<',
      '>=': '≥',
      '<=': '≤',
      '==': '=',
      '!=': '≠',
      'contains': 'contains',
    };
    return `${fieldLabels[conditionField] || conditionField} ${operatorLabels[conditionOperator] || conditionOperator} ${conditionValue}`;
  };

  return (
    <div
      className={`
        relative px-4 py-3 rounded-xl border-2 min-w-[180px]
        bg-gradient-to-br from-purple-500/20 to-purple-600/10
        ${selected ? 'border-purple-400 shadow-lg shadow-purple-500/30' : 'border-purple-500/50'}
        transition-all duration-200
      `}
    >
      {/* Input Handle */}
      <Handle
        type="target"
        position={Position.Top}
        className="!w-3 !h-3 !bg-purple-400 !border-2 !border-purple-600"
      />
      
      {/* Node Header */}
      <div className="flex items-center gap-2 mb-1">
        <div className="p-1.5 rounded-lg bg-purple-500/30">
          <GitBranch className="h-4 w-4 text-purple-400" />
        </div>
        <span className="text-xs font-medium text-purple-400 uppercase tracking-wide">
          Condition
        </span>
      </div>
      
      {/* Condition Label */}
      <div className="text-sm font-semibold text-white mb-2">
        If / Else
      </div>
      
      {/* Condition Preview */}
      <div className="text-xs text-purple-300 bg-purple-500/10 px-2 py-1 rounded">
        {formatCondition()}
      </div>
      
      {/* Output Handles - Yes and No branches */}
      <div className="flex justify-between mt-3 px-2">
        <div className="flex flex-col items-center">
          <span className="text-[10px] text-green-400 mb-1">Yes</span>
          <Handle
            type="source"
            position={Position.Bottom}
            id="yes"
            className="!relative !transform-none !w-3 !h-3 !bg-green-400 !border-2 !border-green-600"
            style={{ left: 'auto', right: 'auto' }}
          />
        </div>
        <div className="flex flex-col items-center">
          <span className="text-[10px] text-red-400 mb-1">No</span>
          <Handle
            type="source"
            position={Position.Bottom}
            id="no"
            className="!relative !transform-none !w-3 !h-3 !bg-red-400 !border-2 !border-red-600"
            style={{ left: 'auto', right: 'auto' }}
          />
        </div>
      </div>
    </div>
  );
}

export const ConditionNode = memo(ConditionNodeComponent);
